/*
 * Off-screen until focused, the standard skip-link pattern: `display: none`
 * or `visibility: hidden` would take it out of the tab order, which is the
 * one thing it exists for.
 */
.skip-link {
	position: absolute;
	inset-inline-start: -9999px;
	top: 0;
	z-index: 1000;
	padding: 8px 12px;
	border-radius: 6px;
	font-size: 14px;
	font-weight: 600;
	text-decoration: none;
	background: var(--cf-app-color-surface, #fff);
	transition: background-color ease-out 220ms;
	color: var(--cf-app-color-ink, #111);
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.skip-link:focus,
.skip-link:focus-visible {
	/* Below the status bar on an installed iOS app, not under it. */
	top: calc(8px + var(--safe-area-inset-top, 0px));
	inset-inline-start: 8px;
	outline: 2px solid var(--ring);
	outline-offset: 2px;
}
